// Environment Configuration
const ENV_CONFIG = {
  development: {
    baseUrl: "http://localhost:3000",
    apiUrl: "http://localhost:8000/api/v1",
    storageUrl: "http://localhost:8000"
  },
  production: {
    baseUrl: "https://scraptrade.com.au",
    apiUrl: "https://scraptrade.com.au/api/v1",
    storageUrl: "https://scraptrade.com.au"
  },
  staging: {
    baseUrl: "https://pixadb.com",
    apiUrl: "https://pixadb.com/api/v1",
    storageUrl: "https://pixadb.com"
  }
};

// Determine current environment based on current URL
const getCurrentEnvironment = () => {
  const currentUrl = window.location.origin;
  
  if (currentUrl.includes("scraptrade.com.au")) {
    return "production";
  } else if (currentUrl.includes("staging")) {
    return "staging";
  } else {
    return "development";
  }
};

const CURRENT_ENV = getCurrentEnvironment();
const CONFIG = ENV_CONFIG[CURRENT_ENV];

export default CONFIG;
